const NODE_ENV = 'development';

// const DEV_BASE_URL = 'https://creditx-node-dev.salesdrive.app/';
const DEV_BASE_URL = 'https://api.creditx.co.in/';
// const DEV_BASE_URL = 'https://solis.api.creditx.co.in/';


// const DEV_BASE_URL = 'https://api.creditx.co.in/';
// const DEV_BASE_URL = 'https://dev.tatacapital.api.creditx.co.in/';


// const UAT_BASE_URL = 'https://creditx-node-dev.salesdrive.app/'; // WE WILL ADD LATER
const UAT_BASE_URL = 'https://api.creditx.co.in/';
// const UAT_BASE_URL = 'https://solis.api.creditx.co.in/';

// const UAT_BASE_URL = 'https://api.creditx.co.in/';  
// const UAT_BASE_URL = 'https://dev.tatacapital.api.creditx.co.in/';

// const PROD_BASE_URL = 'https://b2bnode.iorta.in/b2b/'; // WE WILL ADD LATER
const PROD_BASE_URL = 'https://api.creditx.co.in/';
// const PROD_BASE_URL = 'https://solis.api.creditx.co.in/';
// const PROD_BASE_URL = 'https://dev.api.creditx.co.in/';
// const PROD_BASE_URL = 'https://dev.tatacapital.api.creditx.co.in/';

// const PR_AMERICANO_DEV_BASE_URL = 'https://pramericanodedev.salesdrive.app/sdx-api/';

// const GOOGLE_MAP_API_KEY ="AIzaSyAZfVPEGAfjlr_TA9ZjBN6SKZpWT2lx1HM" ;

const _config = {
  baseURL: NODE_ENV === 'development' ? DEV_BASE_URL : NODE_ENV === 'uat' ? UAT_BASE_URL : PROD_BASE_URL,
  auth: 'auth/',
 // secure: 'secure/',
  secure: '',
  NODE_ENV: NODE_ENV
};

export default _config;
